import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/index.scss';
import { Provider } from 'react-redux';
import { configRequest } from './api/cms';
import applicationStore from './store/store.ts';
import { initDebug } from './utils/debug';
import { getAppProp } from './utils/props';
import { COMMON_HEADERS } from './utils/request';

COMMON_HEADERS.append('x-project-id', getAppProp('project_id'));
COMMON_HEADERS.append('Device', 'mobile');
COMMON_HEADERS.append('x-locale', 'ENG');
initDebug();

const root = document.getElementById('root');

if (!root) {
  throw new Error('No root element found');
}

const renderApp = () => {
  createRoot(root).render(
    <StrictMode>
      <Provider store={applicationStore}>
        <App />
      </Provider>
    </StrictMode>,
  );
};

if (import.meta.env.DEV && import.meta.env.VITE_APP_CONFIG === 'CMS') {
  configRequest()
    .then((config) => {
      window.__APP_CONFIG__ = config;
    })
    .then(renderApp);
} else {
  renderApp();
}
